<template>
	<div class="main">
		<header class="page-title">
			<h2>Provider Comparison Table</h2>
		</header>
		<div class="flex box">
			<div class="three-md form-group">
				<label for="provider-type-selector">Provider Type</label>
				<select :disabled="!loaded" id="provider-type-selector" v-model="selectedProviderType" @change="fetchProviderLists">
					<option :value="providerType.id" v-for="providerType in providerTypes">{{providerType.name}}</option>
				</select>
			</div>
			<div class="nine-md form-group">
				<label for="provider-list-selector">Provider List</label>
				<div class="input-group">
					<select :disabled="!loaded" id="provider-list-selector" v-model="selectedProviderList">
						<option :value="null">Select a list</option>
						<option :value="providerList.id" v-for="providerList in orderedProviderLists">{{providerList.name}}</option>
					</select>
					<a class="btn btn-md btn-primary" :disabled="!loaded" @click="fetchProviderProperties">Compare Providers</a>
				</div>
			</div>
		</div>
		<div v-if="!loaded" class="flex center text-center mb-1">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>
		<div v-if="loaded && providersLoaded && selectedProviderList !== null">
			<div class="form-group">
				<label for="properties-shortcode-hidden">Shortcode</label>
				<input type="text" id="properties-shortcode-hidden" readonly v-model="shortcodeProperties" @click="copyToClipboard(shortcodeProperties)">
			</div>
			<div v-for="propertiesGroup in availableProperties" v-if="propertiesGroup.hidden === false">
				<h3>{{propertiesGroup.name}} (#{{propertiesGroup.id}})</h3>
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th></th>
								<th>#id</th>
								<th>Compare</th>
								<th :id="provider.id" v-for="provider in providerLists[selectedProviderList].bare_providers">{{provider.name}}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="property in propertiesGroup.properties">
								<td><input type="checkbox" v-model="selectedProperties[property.id]"></td>
								<td>{{ property.id }}</td>
								<td>{{property.name}}</td>
								<td v-for="baseProvider in providerLists[selectedProviderList].bare_providers" :class="{ 'td-success' : getPropertyValueFromRaw(baseProvider.id,property.id,property.type) === 'Yes','td-danger' : getPropertyValueFromRaw(baseProvider.id,property.id,property.type) === 'No'}">{{getPropertyValueFromRaw(baseProvider.id,property.id,property.type)}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				providerTypes: {},
				selectedProviderType: null,
				providerLists: {},
				orderedProviderLists: {},
				selectedProviderList: null,

				providerProperties: {},
				availableProperties: {},

				selectedProperties: [],

				loaded: false,
				providersLoaded: false,
			}
		},
		created() {
			this.loadParameters(true);
		},
		methods: {
			copyToClipboard: function(text) {
				let vm = this;
				const input = document.getElementById('properties-shortcode-hidden');
				input.focus();
				input.select();
				document.execCommand('copy');
				vm.$toastr.success('Copying to clipboard was successful!');
			},
			loadParameters: function (init = false) {
				this.selectedProviderType = this.getParameterByName('type') !== null ? this.getParameterByName('type') : 1;
				this.selectedProviderList = this.getParameterByName('id');
				if (init === true && this.getParameterByName('id') === null && this.getParameterByName('type') === null) {
					this.selectedProviderList = 1;
				}
				this.fetchProviderTypes(init);
				this.fetchProviderLists(init);
				this.fetchProviderProperties();
				this.updateUrl();
			},
			fetchProviderTypes: function (init) {
				let vm = this;
				this.providersLoaded = false;
				axios.get('/api/' + vm.$selectedSite.slug + '/providers/compare/getprovidertypes')
						.then(response => {
							vm.providerTypes = _.orderBy(response.data.providerTypes, ['name'], ['asc']);
							if (init !== true) {
								vm.selectedProviderList = null;
							}
							vm.updateUrl();
							if (init !== true || (init === true && vm.selectedProviderList === null)) {
								vm.loaded = true;
							}
							vm.$forceUpdate();

						})
						.catch(e => {
							vm.$toastr.error('Api in ListRenderer failed', 'Error');
						});
			},
			fetchProviderLists: function (init = false) {
				this.loaded = false;
				this.providersLoaded = false;
				let vm = this;
				this.updateUrl();
				axios.get('/api/' + vm.$selectedSite.slug + '/providers/compare/getproviderlists/' + vm.selectedProviderType)
						.then(response => {
							if (init !== true) {
								vm.selectedProviderList = null;
							}
							if (init !== true || (init === true && vm.selectedProviderList === null)) {
								vm.loaded = true;
							}
							vm.orderedProviderLists = _.orderBy(response.data.providerLists, ['name'], ['asc']);
							vm.providerLists = response.data.providerLists;
							vm.updateUrl();
							vm.$forceUpdate();
						})
						.catch(e => {
							vm.$toastr.error('Api in ListRenderer failed', 'Error');
						});
			},
			fetchProviderProperties: function () {
				let vm = this;
				this.loaded = false;
				this.updateUrl();
				if (this.selectedProviderList === null) {
					return true;
				}

				axios.get('/api/' + vm.$selectedSite.slug + '/providers/compare/getproviderproperties/' + vm.selectedProviderList)
						.then(response => {
							vm.providerProperties = response.data.properties;
							vm.availableProperties = vm.providerProperties[Object.keys(vm.providerProperties)[0]].availableProperties;
							vm.loaded = true;
							vm.providersLoaded = true;
						})
						.catch(e => {
							vm.$toastr.error('Api in ListRenderer failed', 'Error');
						});
			},
			getPropertyValueFromRaw: function (baseProviderId, propertyId, type) {
				let value = this.providerProperties[baseProviderId].providerProperties[propertyId].value;
				try {
					return value.en.value;
				} catch (error) {
					if (type === 'checkbox') {
						if (value === '1') {
							value = 'Yes';
						} else if (value === '0') {
							value = 'No';
						} else value = 'N/A'
					}
					return value;
				}
			},
			getParameterByName: function (name, url) {
				if (!url) url = window.location.href;
				name = name.replace(/[\[\]]/g, '\\$&');
				let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
						results = regex.exec(url);
				if (!results) return null;
				if (!results[2]) return '';
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			},

			updateUrl: function (clean = false) {
				let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
				let parameters = [];

				if (this.selectedProviderType !== null) {
					parameters.push('type=' + this.selectedProviderType);
				}
				if (this.selectedProviderList !== null) {
					parameters.push('id=' + this.selectedProviderList);
				}
				if (parameters.length > 0) {
					parameters = parameters.join('&');
					newurl += '?' + parameters;
				}
				window.history.pushState({path: newurl}, '', newurl);
			},
		},
		computed: {
			shortcodeProperties: function () {
				let vm = this;
				let text = '';
				if(vm.selectedProperties.length > 0) {
					for (let i = 0; i < vm.selectedProperties.length; i++) {
						if(vm.selectedProperties[i] && vm.selectedProperties[i] === true) {
							if(text.length > 0) {
								text = text + ',' + i.toString();
							} else {
								text = i.toString();
							}
						}
					}
				}
				return '[[post-object type="comparison" properties="' + text + '" /]]';
			}
		}
	}
</script>

<style scoped>

</style>
